export default __webpack_public_path__ + "static/A_rare_silk_nearly_lost_through_war_Hero_thumb-6f0a2d4861132b78f88845136c1a8442.jpg";